import { convertToMapById } from "helpers/convertToMap";
import { createSelector } from "reselect";

export const unitsSelector = createSelector(
  (state) => {
    const stations = state.companies.stations
    const { unitsConfig, stationsParent } = state.unitsReducer
    return Object.keys(unitsConfig).length > 0 ? convertToMapById(state.unitsReducer.unitsConfig).map(unit => {
      let tags = []
      let newStringLabel = ''
      let tagsJoined = ''
      if( unit.tags !== null && unit.tags.length > 0 ) {
          tags = unit.tags.map(tag => state.tagsReducer.tags[tag]?.label)
          tagsJoined = tags.join(' | ')

        if(tagsJoined.length > 15) {
          newStringLabel = tagsJoined.substring(0, 15) + `... (${ tags.length } etiquetas)`
        }
      }
      return {
        ...unit,
        brand: state.brandsReducer?.brands[unit?.idStationBrand]?.name ? `${state.brandsReducer?.brands[unit?.idStationBrand]?.name} - ${state.brandsReducer?.brands[unit?.idStationBrand]?.logo}` : '',
        tagsLabel: tags,
        tagsString: newStringLabel,
        uStation: stations[unit.idStation].label,
        uOperative: stationsParent.find(st => st.id === unit.idOperating)?.name
      }
    }) : []
  },
  (units) => {
    return units
  }
);

export const tagsSelector = createSelector(
  (state) => {
    const tags = state.tagsReducer.tagsList
    const stations = state.companies.stations
    const unitStationId = state.unitsReducer.station?.id || ''
    const tagsFiltered = tags.filter(tag => tag.idStation === unitStationId).map(tg => {
      return {
        ...tg,
        station: stations[tg.idStation].name
      }
    })
    return tagsFiltered || []
  },
  (tags) => {
    return tags
  }
);